import { useLocation } from 'react-router-dom';

export const useIs40xPage = () => {
    const location = useLocation();
    return location.pathname.startsWith('/error/401');
};
